import { Instance } from 'mobx-state-tree';
import { TemplateReviewResultPublicDtoModelBase } from './TemplateReviewResultPublicDtoModel.base';

/* The TypeScript type of an instance of TemplateReviewResultPublicDtoModel */
export interface TemplateReviewResultPublicDtoModelType extends Instance<typeof TemplateReviewResultPublicDtoModel.Type> {}

/* A graphql query fragment builders for TemplateReviewResultPublicDtoModel */
export { selectFromTemplateReviewResultPublicDto, templateReviewResultPublicDtoModelPrimitives, TemplateReviewResultPublicDtoModelSelector } from './TemplateReviewResultPublicDtoModel.base';

/**
 * TemplateReviewResultPublicDtoModel
 */
export const TemplateReviewResultPublicDtoModel = TemplateReviewResultPublicDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
